module.exports = __webpack_public_path__ + "img/ald.58bb821e.png";